import { motion } from 'framer-motion';
import { Shield, Target, Users } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#0B0B0D] flex flex-col">
      <SEO
        title="About | Subsurface — Trust & Risk Architecture Consultancy"
        description="Founded by Garry Cameron, Subsurface is a Trust and Risk Architecture consultancy for SaaS, fintech and e-commerce teams. Diagnostics, structured reviews and trust monitoring."
        path="/about"
      />
      <Navigation />

      <div className="flex-1 pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-16"
          >
            <h1 className="text-5xl md:text-6xl font-bold font-display mb-6">About Subsurface</h1>
            <p className="text-xl text-[#A0A0A0] leading-relaxed">
              We help digital businesses identify trust gaps before they cost revenue.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="space-y-12"
          >
            <div className="glass-card p-8 rounded-lg">
              <h2 className="text-3xl font-display font-semibold mb-4">What We Do</h2>
              <p className="text-[#A0A0A0] leading-relaxed mb-4">
                Subsurface is a Trust & Risk Intelligence platform designed for SaaS, fintech, and e-commerce businesses. We surface hidden friction across product flows, payment systems, and user experiences that erode trust and leak revenue.
              </p>
              <p className="text-[#A0A0A0] leading-relaxed">
                Through structured diagnostics, expert analysis, and commercial judgment, we help companies understand where trust breaks down, and what it costs them.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="glass-card p-6 rounded-lg">
                <Shield className="w-10 h-10 text-[#FF6A00] mb-4" />
                <h3 className="text-xl font-display font-semibold mb-2">Trust-First</h3>
                <p className="text-sm text-[#A0A0A0]">We focus on trust signals, not just bugs. Every issue is assessed for commercial relevance.</p>
              </div>

              <div className="glass-card p-6 rounded-lg">
                <Target className="w-10 h-10 text-[#FF6A00] mb-4" />
                <h3 className="text-xl font-display font-semibold mb-2">Revenue-Focused</h3>
                <p className="text-sm text-[#A0A0A0]">We prioritize issues that impact growth, conversion, and customer confidence.</p>
              </div>

              <div className="glass-card p-6 rounded-lg">
                <Users className="w-10 h-10 text-[#FF6A00] mb-4" />
                <h3 className="text-xl font-display font-semibold mb-2">Expert-Led</h3>
                <p className="text-sm text-[#A0A0A0]">Human judgment layer ensures credibility, materiality, and urgency assessment.</p>
              </div>
            </div>

            <div className="glass-card p-8 rounded-lg">
              <h2 className="text-3xl font-display font-semibold mb-4">Who We Serve</h2>
              <p className="text-[#A0A0A0] leading-relaxed">
                We work with high-growth digital businesses where trust failures translate directly to revenue loss: SaaS platforms managing complex user flows, fintech products handling sensitive transactions, and e-commerce systems where checkout friction kills conversion.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;
